/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const DeleteSvg = () => (
  <svg
    width="9"
    height="13"
    viewBox="0 0 9 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.642858 11.0345C0.642858 11.7931 1.22143 12.4138 1.92857 12.4138H7.07143C7.77858 12.4138 8.35715 11.7931 8.35715 11.0345V2.75862H0.642858V11.0345ZM9.00001 0.689656H6.75L6.10715 0H2.89286L2.25 0.689656H0V2.06897H9.00001V0.689656Z"
      fill="currentColor"
    />
  </svg>
)

const DeleteIcon = (props) => <Icon component={DeleteSvg} {...props} />

export { DeleteIcon }
